// extracted by mini-css-extract-plugin
module.exports = {"PlaceCard":"PlaceCard_PlaceCard__1UBe0","Image":"PlaceCard_Image__1o5K-","Title":"PlaceCard_Title__2gfye","Container":"PlaceCard_Container__3Tj-6"};